import React from 'react';
import PropTypes from 'prop-types';
import { StyledDialog } from './styles.js';

export const FullScreenDialog = ({ children, ...rest }) => {
  return <StyledDialog {...rest}>{children}</StyledDialog>;
};

FullScreenDialog.propTypes = {
  children: PropTypes.node
};
export default FullScreenDialog;



// WEBPACK FOOTER //
// ./src/vp-ui/dialogs/FullScreenDialog/FullScreenDialog.jsx